// Action Types
export const SET_DYNAMIC_INSIGHT_EVENTS = 'dynamicInsights/setDynamicInsightEvents'
export const RESET_DYNAMIC_INSIGHT_EVENTS = 'dynamicInsights/resetDynamicInsightEvents'
export const SET_IS_LOADING = 'dynamicInsights/setIsLoading'

// Action Creators
export const setDyanmicInsightEvents = (payload) => ({ type: SET_DYNAMIC_INSIGHT_EVENTS, payload })
export const resetDynamicInsightEvents = () => ({ type: RESET_DYNAMIC_INSIGHT_EVENTS })
export const setIsLoading = (payload) => ({ type: SET_IS_LOADING, payload })

// State
export const initialState = {
  session_id: '',
  categories: [],
  preconditions: [],
  type: '',
  stage: '',
  stage_items_total: null,
  stage_items_completed: null,
  stage_remaining: null,
  total_remaining: null,
  fraction_irrelevant: 0,
  anchors: {},
  err: '',
  loading: false,
  precondition_statements: [],
  precondition_questions: [],
}

export default function dynamicInsightEventsReducer(state = initialState, action) {
  const { payload, type } = action

  switch (type) {
    case SET_DYNAMIC_INSIGHT_EVENTS:
      return { ...state, ...JSON.parse(payload) }
    case RESET_DYNAMIC_INSIGHT_EVENTS:
      return { ...initialState }
    case SET_IS_LOADING:
      return { ...state, loading: payload }
    default:
      return state
  }
}
